import { render, staticRenderFns } from "./liveliveAnswers.vue?vue&type=template&id=6c5a7a52&scoped=true"
import script from "./liveliveAnswers.vue?vue&type=script&lang=js"
export * from "./liveliveAnswers.vue?vue&type=script&lang=js"
import style0 from "./liveliveAnswers.vue?vue&type=style&index=0&id=6c5a7a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a7a52",
  null
  
)

export default component.exports